import React from "react";
import { useCreditDispatch } from "../../stores/credit/credit.store";
import { openCredit } from "../../stores/credit/credit.reducer";
import { useProductSelector } from "../../stores/product/product.store";
import { ProductState } from "../../stores/product/product-state.interface";
import { ProductInterface } from "../../interfaces/product/product.interface";
interface CartButtonProps {
    product: ProductInterface;
    onClick?: () => void;
}

export const CartButton: React.FC<CartButtonProps> = ({ product, onClick }) => {
    const translate = useProductSelector((state: ProductState) => state.translate);
    const dispatch = useCreditDispatch();
    const open = (id: number, month: number) => {
        dispatch(openCredit({ id, month }));
    }

    const click = () => {
        if(onClick) onClick();
    }

    return (
        <>
            <button onClick={ () => click() } className="rounded-2xl p-4 w-full mb-4 bg-yellow font-bold text-[16px] md:min-h-[54px] min-h-[52px]">{ product.needUpdate ? '' : translate.cart }</button>
            <button onClick={() => open(1,1 )} className="rounded-2xl p-4 w-full bg-[#f78122] font-bold text-[16px] md:min-h-[54px] min-h-[52px]">{ product.needUpdate ? '' : translate.inCredit } { product.needUpdate ? '' : product.minCredit?.monthText }</button>
        </>
    )
}